import { ProfileSection } from './ProfileSection';

export default ProfileSection;
